(function(){
    'use strict';

    angular
       .module('appback')
       .factory('AlertasService', AlertasService);

   AlertasService.$inject = ['$http'];

   function AlertasService($http){


       var service= {
          getAllAlertas:getAllAlertas
       };

       return service;
       function getAllAlertas(callback) {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/alertas/getallalertasconproducto', { params : {}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('failed', data)
                
                return false;
            }
        
       }
   }
})();